/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_BrowseInputs */

const en_google_drive_browse = /** @type {(inputs: Google_Drive_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Drive files`)
};

const es_google_drive_browse = /** @type {(inputs: Google_Drive_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar archivos de Drive`)
};

/**
* | output |
* | --- |
* | "Browse Drive files" |
*
* @param {Google_Drive_BrowseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_browse = /** @type {((inputs?: Google_Drive_BrowseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_BrowseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_browse(inputs)
	return en_google_drive_browse(inputs)
});